import { sedrApi } from '../../api/sedr';
import { applyI18n, t } from '../../i18n';
import { bindLocaleRefresh } from '../../i18n/bindLocaleRefresh';
import { bindModalDismiss, createModalShell } from '../../ui/modalDialogShell';
import { sedrErrorMessageKey } from './sedrErrors';
import { folderDepth, sortedFolderTree } from './sedrStarterSetFolders';

export function showSedrFolderStarterSetPreviewDialog(options: {
  setId: string;
  setName: string;
}): void {
  const shell = createModalShell({
    titleKey: 'sedr.import.folderSetPreviewTitle',
    titleId: 'sedr-folder-set-preview-title',
    className: 'sedr-folder-set-preview-dialog',
  });

  shell.body.innerHTML = `
    <p class="muted" id="sedr-folder-set-preview-subtitle"></p>
    <div class="sedr-folder-set-preview__list" id="sedr-folder-set-preview-list"></div>
    <p class="error-text" id="sedr-folder-set-preview-error" hidden></p>
  `;

  const subtitleEl = shell.body.querySelector('#sedr-folder-set-preview-subtitle') as HTMLParagraphElement;
  subtitleEl.textContent = options.setName;

  const listEl = shell.body.querySelector('#sedr-folder-set-preview-list') as HTMLDivElement;
  const errorEl = shell.body.querySelector('#sedr-folder-set-preview-error') as HTMLParagraphElement;

  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'button ghost';
  closeButton.setAttribute('data-i18n', 'sedr.import.hubClose');
  shell.actions.append(closeButton);

  document.body.append(shell.backdrop);
  applyI18n(shell.dialog);

  let lastErrorKey = 'status.error';

  const refreshLocale = () => {
    if (!errorEl.hidden) {
      errorEl.textContent = t(lastErrorKey);
    }
    applyI18n(shell.dialog);
  };
  const unbindLocale = bindLocaleRefresh(refreshLocale);

  const close = () => {
    unbindLocale();
    unbindDismiss();
    shell.backdrop.remove();
  };

  const unbindDismiss = bindModalDismiss({
    backdrop: shell.backdrop,
    closeButton: shell.closeButton,
    onClose: close,
  });
  closeButton.addEventListener('click', close);

  void (async () => {
    try {
      const detail = await sedrApi.getStarterSet(options.setId);
      const folders = sortedFolderTree(detail.folders);
      listEl.replaceChildren();

      if (folders.length === 0) {
        const empty = document.createElement('p');
        empty.className = 'muted';
        empty.setAttribute('data-i18n', 'sedr.library.emptyFolders');
        listEl.append(empty);
        applyI18n(listEl);
        return;
      }

      const ul = document.createElement('ul');
      ul.className = 'sedr-folder-set-preview__tree';
      for (const folder of folders) {
        const li = document.createElement('li');
        li.className = 'sedr-folder-set-preview__node';
        li.style.paddingLeft = `${folderDepth(folders, folder.id) * 1.1}rem`;
        li.textContent = folder.name;
        ul.append(li);
      }
      listEl.append(ul);
    } catch (cause) {
      lastErrorKey = sedrErrorMessageKey(cause);
      errorEl.hidden = false;
      errorEl.textContent = t(lastErrorKey);
    }
  })();
}
